import { ol_LayerBase, ol_Collection, ol_source, ol_layer } from "@omnia/exports/openlayers"
import { IOmniaSettings, LocaleString } from "../../types"
import { Basemap } from "./basemap"
import { BasemapGroup } from "./group"

export function createDefaultBasemaps(targetLayers: ol_Collection<ol_LayerBase>, bingKey: string, settings: IOmniaSettings): BasemapGroup {

    const layer = new ol_layer.Tile()
    targetLayers.insertAt(0, layer)

    const msgRoadmap = "Road Map"

    const basemaps = [

        new Basemap(
            "Bing with labels" as LocaleString,
            layer,
            () => new ol_source.BingMaps({
                key: bingKey,
                imagerySet: 'AerialWithLabels',
                maxZoom: 19,
                placeholderTiles: true
            })
        ),

        new Basemap(
            "Bing",
            layer, () => new ol_source.BingMaps({
                key: bingKey,
                imagerySet: 'Aerial',
                maxZoom: 19,
                placeholderTiles: true
            })
        ),

        new Basemap(
            "Ordnance Survey",
            layer,
            () => new ol_source.BingMaps({
                key: bingKey,
                imagerySet: 'ordnancesurvey',
                maxZoom: 17,
                placeholderTiles: true
            })
        ),

        new Basemap(msgRoadmap, layer, () => new ol_source.OSM({})),

    ]

    return new BasemapGroup(
        "std",
        basemaps,
        layer,
        settings.getSettings("basemap"),
        false,
        false,
        {
            name: msgRoadmap,
            visible: true
        }
    )

}
